import { Button, Box, Tooltip } from "@material-ui/core";
import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";

import { Loading } from "../../components/shared/loading";
import { UserContext } from "../../contexts/UserContext";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";

import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

export const AllTeam = () => {
  const navigate = useNavigate();
  const classes = useAdminStyles();
  const toast = useToast();
  const { setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = () => {
    Axios.get("/api/select_team", {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.status === 200) {
        setData(res.data.data || []);
        setLoading(false);
        $(document).ready(function () {
          $("#team_table").DataTable({
            destroy: true,
            scrollX: true,
          });
        });
      } else {
        setUser(null);
        navigate("/");
      }
    });
  };

  const toggleStatus = (id, currentStatus) => {
    const formdata = new FormData();
    formdata.append("idd", id);
    Axios.post("/api/team_status", formdata, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.status === 200) {
        toast.success(
          currentStatus === 1 ? "Member deactivated" : "Member activated"
        );
        getData();
      } else {
        toast.error("Failed to update status");
      }
    });
  };

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>All Team - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Manage"
        title="Team members"
        subtitle="Add and edit leadership and core developer profiles."
        actions={
          <Button
            component={Link}
            to="/dash/addteam"
            className={classes.primaryBtn}
            startIcon={<AddIcon />}
          >
            Add Member
          </Button>
        }
      />

      <Box className={classes.tableWrap}>
        <table id="team_table" className="display" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Designation</th>
              <th>Image</th>
              <th>Role</th>
              <th>Priority</th>
              <th>Status</th>
              <th>Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((da) => (
              <tr key={da.id}>
                <td>{da.id}</td>
                <td style={{ fontWeight: 600, color: "#1a1a1a" }}>{da.name}</td>
                <td style={{ color: "#9b3b9b", fontSize: "0.76rem" }}>
                  {da.designation}
                </td>
                <td>
                  {da.image ? (
                    <img
                      src={"/static/team/" + da.image}
                      alt={da.name}
                      style={{ height: 56, width: 56, objectFit: "cover" }}
                    />
                  ) : (
                    <span style={{ color: "#9ca3af", fontSize: "0.74rem" }}>
                      No image
                    </span>
                  )}
                </td>
                <td>{da.role_name}</td>
                <td>{da.priority}</td>
                <td>
                  {da.status === 1 ? (
                    <span className={`${classes.badge} ${classes.badgeActive}`}>
                      <CheckCircleOutlineIcon /> Active
                    </span>
                  ) : (
                    <span className={`${classes.badge} ${classes.badgeInactive}`}>
                      <RemoveCircleOutlineIcon /> Inactive
                    </span>
                  )}
                </td>
                <td>{da.added_date}</td>
                <td>
                  <Box className={classes.actionCell}>
                    <Tooltip title="Edit" arrow>
                      <Link
                        to={"/dash/updateteam/" + da.id}
                        className={classes.iconBtn}
                        aria-label="Edit"
                      >
                        <EditOutlinedIcon />
                      </Link>
                    </Tooltip>
                    <Tooltip
                      title={da.status === 1 ? "Deactivate" : "Activate"}
                      arrow
                    >
                      <button
                        type="button"
                        className={classes.iconBtn}
                        onClick={() => toggleStatus(da.id, da.status)}
                        aria-label={da.status === 1 ? "Deactivate" : "Activate"}
                      >
                        {da.status === 1 ? (
                          <VisibilityOffOutlinedIcon />
                        ) : (
                          <VisibilityOutlinedIcon />
                        )}
                      </button>
                    </Tooltip>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
